<template>
    <div class="animated fadeIn custom-cases bgV2 safetyApp">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button v-if="Item.status && ['Submitted'].includes(Item.status)" class="mr-3" label="Toolbox Meeting Report" @click="reportJob"></gofix-button>
                        <gofix-button
                            :disabled="!$checkRole(this.$accessModule.toolbox_meeting, 'update')"
                            class="mr-3" 
                            label="NEXT ACTION"
                            @click="changeStatus" outline>
                        </gofix-button>
                        <gofix-button
                            :disabled="!$checkRole(this.$accessModule.toolbox_meeting, 'update') || (Item.status != 'New' && Item.status != 'Rejected')"
                            :loading="loadingSave"
                            @click="updateData"
                            label="SAVE">
                        </gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <detail-info @reloadItem="getItem" ref="basic-info"></detail-info>
                        <detail-workers></detail-workers>
                    </template>
                    <template slot="gofixTab:signature">
                        <signature :job="Item"></signature>
                    </template>
                    <template slot="gofixTab:activity-log">
                        <activities ref="activities" activityType="Job Safety" :activityId="$route.params.id"></activities>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    const Activities = () => import("../activities")
    const DetailInfo = () => import("./detail-info")
    const DetailWorkers = () => import("./detail-workers")
    const ViewerImage = () => import('../../plugins/ViewerImage.vue')
    const Signature = () => import("../detail-signature")
    export default {
        name: 'safety-induction-training-detail',
        components: {
            DetailInfo,
            DetailWorkers,
            Activities,
            ViewerImage,
            Signature
        },
        data() {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                    {
                        key: "signature",
                        title: "Signature",
                        active: false
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false
                    }
                ],
                loadingSave: false,
                timer_save: null,
                timer_report: null,
            }
        },
        computed: {
            ...mapGetters({
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyJob',
            })
        },
        watch: {
        },
        created() {
            if (
                !this.$route.params.hasOwnProperty("id") ||
                isNaN(this.$route.params.id)
            ) {
                return this.$router.push({
                    name: "safety-toolbox-meeting"
                });
            }
            this.getItem()
        },
        methods: {
            /*-- Get Data --------*/
            getItem() {
                this.loadingDetail = true
                this.$store.dispatch( 'SafetyAppController/getSafetyToolboxMeetingItem', this.$route.params.id)
                .then(response => {
                    // this.item = Object.assign(this.item, response)
                    this.loadingDetail = false
                })
                .catch(err => {
                    console.log(err)
                    this.loadingDetail = false
                })
            },
            changeStatus() {
                this.$refs['basic-info'].editBacsicInfo()
            },

            /*-- Store Data --------*/
            updateData() {
                if (this.timer_save) {
                    clearTimeout(this.timer_save);
                    this.timer_save = null;
                }
                this.timer_save = setTimeout(async () => {
                    const data = this.$refs['basic-info'].info;
                    const validate_fields = [
                        { key: 'project', name: 'Project'},
                        { key: 'topics', name: 'Topics'},
                        { key: 'equipment', name: 'Conducted at'},
                        { key: 'planned_date', name: 'Date'},
                        { key: 'start_time', name: 'Start time'},
                        { key: 'end_time', name: 'End time'},
                    ]
                    const is_validate = this.$validationData(validate_fields, data)
                    if(is_validate) return

                    if(this.loadingSave) return;
                    this.loadingSave = true;

                    let objeClone = {
                        client_contract_id: data.client_contract_id,
                        project_id: data.project.id,
                        location_id: data.equipment.location_id,
                        location: data.equipment.name,
                        // equipment_id: data.equipment.id,
                        // equipment_lift_number: data.equipment.equipment_lift_number,
                        // equipment_type: data.equipment.equipment_type,
                        topics: data.topics,
                        supplier_id: data.supplier && data.supplier.id ? data.supplier.id : null,
                        supplier: data.supplier && data.supplier.name ? data.supplier.name : null,
                        contractor_supervisor_id: data.contractor_supervisor_by ? data.contractor_supervisor_by.user_id : null,
                        planned_date: data.planned_date ? moment(data.planned_date).format('YYYY-MM-DD') : null,
                        start_time: data.start_time ? data.start_time : null,
                        end_time: data.end_time ? data.end_time : null,
                        // locations: data.locations ? data.locations : null,
                        property_manager_id: data.property_manager_by ? data.property_manager_by.user_id : null,
                        safety_officer_id: data.safety_officer_by ? data.safety_officer_by.user_id : null,
                        comment: data.comment_cs && data.comment_cs.description ? data.comment_cs.description : null,
                    };

                    if(data.project && data.project.client_contract_id) {
                        objeClone.client_contract_id = data.project.client_contract_id
                    }

                    const attachment = this.$refs['basic-info'].attachment;
                    let photos = attachment.items || []
    
                    this.$store.dispatch(`SafetyAppController/updateSafetyToolboxMeetingItem`, {
                        id: data.id,
                        data: objeClone,
                        photos: photos
                    })
                    .then(async response => {
                        this.loadingSave = false;
                        if(response.code && response.message) {
                            this.$alertNotification(response.message, "danger");
                            return;
                        }
                        this.$refs['basic-info'].resetAttachment()
                        await this.getItem()
                        this.$alertNotification(this.$notificationV2('editing', 'toolbox_meeting'), "success");
                    })
                    .catch(err => {
                        console.log(err)
                        this.loadingSave = false;
                        if( err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    })

                }, 200);
            },
            reportJob() {
                if (this.timer_report) {
                    clearTimeout(this.timer_report);
                    this.timer_report = null;
                }
                this.timer_report = setTimeout(() => {
                    let nameFile = `${this.Item.job_number}.pdf`;
                    console.log(nameFile);
                    this.$store.dispatch("SafetyAppController/reportSafetyToolboxMeetingItem", this.$route.params.id)
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', nameFile);
                        document.body.appendChild(link);
                        link.click();
                    });
                }, 300);
            },
        }
    }
</script>